import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceWorkingConfinedSpacesSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.WorkingConfinedSpaces}
        >
            <h4>Please indicate whether the work that you will be carrying out involves any of the following confined space situations:</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.StorageTanks),
                    getQuestionConfig(props.questionConfigs, questionIds.StorageTanksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Silos),
                    getQuestionConfig(props.questionConfigs, questionIds.SilosFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Sewers),
                    getQuestionConfig(props.questionConfigs, questionIds.SewersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Vats),
                    getQuestionConfig(props.questionConfigs, questionIds.VatsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.Ductwork),
                    getQuestionConfig(props.questionConfigs, questionIds.DuctworkFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.PoisonousGas),
                    getQuestionConfig(props.questionConfigs, questionIds.PoisonousGasFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ResiduesLeftInTanks),
                    getQuestionConfig(props.questionConfigs, questionIds.ResiduesLeftInTanksFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ReactionVessels),
                    getQuestionConfig(props.questionConfigs, questionIds.ReactionVesselsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EnclosedDrains),
                    getQuestionConfig(props.questionConfigs, questionIds.EnclosedDrainsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.OpenToppedChambers),
                    getQuestionConfig(props.questionConfigs, questionIds.OpenToppedChambersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.CombustionChambers),
                    getQuestionConfig(props.questionConfigs, questionIds.CombustionChambersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.UnventilatedPoorlyVentilatedRooms),
                    getQuestionConfig(props.questionConfigs, questionIds.UnventilatedPoorlyVentilatedRoomsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HotConditions),
                    getQuestionConfig(props.questionConfigs, questionIds.HotConditionsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.DustPresentHighConcentrations),
                    getQuestionConfig(props.questionConfigs, questionIds.DustPresentHighConcentrationsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceWorkingConfinedSpacesSection = connect(makeMapStateToQuestionnaireSectionProps(sections.WorkingConfinedSpaces.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceWorkingConfinedSpacesSectionUnconnected);
